import { utils } from 'gipsy-misc';

import axios from './utils/axios';

export function getAuthURL() {
  var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var url = '/slack/authurl';
  if (teamId) {
    url = utils.request.appendToUrl(url, { teamId: teamId });
  }
  return axios.get(url);
}
//# sourceMappingURL=slack.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/slack.js
// module id = 1085
// module chunks = 0